var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ arrow: true, theme: 'green', placement: 'bottom' }),expression:"{ arrow: true, theme: 'green', placement: 'bottom' }"}],attrs:{"content":`Nível ${_vm.tier}`}},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('span',{staticClass:"sr-only"},[_vm._v(" Nível "+_vm._s(_vm.tier)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }